import React, { Fragment } from 'react';
import { useTranslations } from '../../providers/DesignSystemI18nProvider';
import { isIe11 } from '../../utils';
import { VisuallyHidden } from '../VisuallyHidden';
import { LOADER_TRANSLATION_KEYS, LoaderSize } from './Loader.constants';
import { LoaderFallbackText, LoaderWrapper } from './Loader.styles';
import { LoaderIcon } from './LoaderIcon';
const IS_IE_11 = isIe11();
export function Loader(_ref) {
  let {
    size
  } = _ref;
  const translate = useTranslations();
  return React.createElement(LoaderWrapper, {
    "data-component": "Loader"
  }, IS_IE_11 ? React.createElement(LoaderFallbackText, null, translate(LOADER_TRANSLATION_KEYS.fallbackText)) : React.createElement(Fragment, null, React.createElement(VisuallyHidden, {
    "data-test-id": "Loader-VisuallyHidden"
  }, translate(LOADER_TRANSLATION_KEYS.fallbackText)), React.createElement(LoaderIcon, {
    size: size
  })));
}
Loader.defaultProps = {
  size: LoaderSize.DEFAULT
};